












































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateBankAccountPocketSuccessViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-bank-account/update-bank-account-pocket-success-view-model';

@Component({ name: 'UpdateBankAccountPocketSuccess' })
export default class UpdateBankAccountPocketSuccess extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_bank_pocket_success_view_model = Vue.observable(
    new UpdateBankAccountPocketSuccessViewModel(),
  );

  closeModal() {
    this.synced_is_open = false;
  }
}
